<template>
    <v-expansion-panel>
        <v-expansion-panel-header>Zeiten</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row>
                <v-col class="col-12">
                    <h3></h3>
                    <v-row class="d-flex flex-wrap">
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_zubereitungszeit"
                                    label="Zubereitungszeit"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_wartezeit"
                                    label="Wartezeit"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_backzeit"
                                    label="Backzeit"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_kuehlzeit"
                                    label="Kühlzeit"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_gefrierdauer"
                                    label="Gefrierdauer"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_kochzeit"
                                    label="Kochzeit"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_schwierigkeitsgrad"
                                    label="Level"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_dauer"
                                    label="Dauer"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_grad"
                                    label="Gradzahl °C"
                            ></v-text-field>
                        </v-col>
                        <v-col class="col-3">
                            <v-text-field
                                    v-model="postItem.attribute_heizart"
                                    label="Heizart"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
  export default {
    name: 'PostRecipeTimesComponent',
    props:['postItem']
  }
</script>

<style scoped>

</style>